export default __webpack_public_path__ + "static/media/Ð¡Ð½Ð¸Ð¼Ð¾Ðº ÑÐºÑÐ°Ð½Ð° 2024-11-04 095447.d7e0def6.png";